import { Zillow } from '../../../assets/zillow'
import ReviewCardSkeleton from '../reviews/review-card-skeleton'

const ReviewsSectionSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <Zillow size={85} />
          <div className="flex flex-col gap-1">
            <div className="h-6 w-24 animate-pulse rounded bg-gray-200" />
            <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
        <div className="mb-4 flex items-center gap-2">
          <div className="h-10 w-16 animate-pulse rounded bg-gray-200" />
          <div className="flex items-center gap-2">
            {[...Array(5)].map((_, index) => (
              <div key={index} className="size-6 animate-pulse rounded bg-gray-200" />
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-2">
          {[...Array(3)].map((_, index) => (
            <ReviewCardSkeleton key={index} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ReviewsSectionSkeleton
